$ = require 'jquery'
actionFilterFromString = require 'lib/util/action-filter-from-string'
ApiAjax = require 'network/api-ajax'
ApiError = require 'network/api-error'
ApiPromise = require 'network/api-promise'
Accounts = require 'common/lib/accounts'
Auth = require 'db/auth'
BoardBackgroundList = require 'models/collections/board-background-list'
BoardList = undefined
queueRequire -> BoardList = require 'models/collections/board-list'
BoardStarList = require 'models/collections/board-star-list'
Controller = require 'controller'
CustomEmojiList = require 'models/collections/custom-emoji-list'
CustomStickerList = require 'models/collections/custom-sticker-list'
DesktopNotification = require 'lib/desktop-notification'
Enterprise = require 'models/enterprise'
EnterpriseList = undefined
queueRequire -> EnterpriseList = require 'models/collections/enterprise-list'
Language = require 'lib/language'
LimitMixin = require 'lib/limit-mixin'
LoginList = require 'models/collections/login-list'
MemberFeatures = require 'data/member-features'
moment = require 'moment'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
ModelWithPreferences = require 'models/internal/model-with-preferences'
Notification = require 'models/notification'
NotificationFilterState = require 'view-models/notification-filter-state'
NotificationsSeenState = require 'view-models/notifications-seen-state'
OrganizationList = undefined
queueRequire -> OrganizationList = require 'models/collections/organization-list'
Payloads = require 'network/payloads'
PluginDataList = require 'models/collections/plugin-data-list'
Promise = require 'bluebird'
SavedSearchList = require 'models/collections/saved-search-list'
getExperiment = require 'lib/experiments/simple-test'
Storage = require 'lib/storage'
Time = require 'lib/time'
track = require 'debug/track'
Util = require 'lib/util'
_ = require 'underscore'
l = require 'lib/localize'
ldclient = require 'lib/ldclient'
mixin = require 'lib/mixin'

# Default new accounts to a simpler detail view
HIDE_DETAILS_DEFAULT_DATE = new Date(2016, 8, 21)

simulateNps = null

module.exports = class Member extends ModelWithPreferences
  mixin LimitMixin, @
  EDITING_AUTO_CLEAR_MS = 10000
  typeName: 'Member'
  nameAttr: 'fullName'
  urlRoot: '/1/members'

  defaults:
    notificationsCount: {}

  initialize: ->
    super
    @destruct [
      @boardList = new BoardList().syncModel(@, 'idBoards')
      @enterpriseList = new EnterpriseList().syncModel(@, 'enterprises',  { fxGetIds: (enterprises) -> _.pluck(enterprises, 'id') })
      @organizationList = new OrganizationList().syncModel(@, 'idOrganizations')
      @pluginDataList = new PluginDataList([], {
        scopeModel: @
      }).syncCache @modelCache, [], (pluginData) =>
        pluginData.get('idModel') == @id && pluginData.get('scope') == 'member'
    ]

    if Auth.isMe(@)
      @destruct [
        @boardStarList = new BoardStarList([], { member: @ }).syncSubModels(@, 'boardStars')
        @savedSearchList = new SavedSearchList([], { member: @ }).syncSubModels(@, 'savedSearches')
        @customStickerList = new CustomStickerList([], { member: @ }).syncSubModels(@, 'customStickers')
        @boardBackgroundList = new BoardBackgroundList([], { member: @ }).syncSubModels(@, 'boardBackgrounds')
        @customEmojiList = new CustomEmojiList([], { member: @ }).syncSubModels(@, 'customEmoji')
        @loginList = new LoginList([], { member: @ }).syncSubModels(@, 'logins')
      ]

      if @isFeatureEnabled('customEmoji')
        ModelLoader.loadMemberCustomEmoji(@id).done()

      @listenTo @modelCache, 'add:Notification', _.debounce(@ensureGroup, 500)
      @listenTo @modelCache, 'rpc:add:Notification', @updateNotificationCount('add')
      @listenTo @modelCache, 'change:Notification:unread', @updateNotificationCount('change')
      @listenTo @modelCache, 'rpc:remove:Notification', @updateNotificationCount('delete')
      @initializeNotifications()

    @listenTo @, 'change:editing', (member) =>
      @modelCache.get('Card', member.get('editing')?.idCard)?.updateEditing(member)

    return

  isVisibleAction: (action) ->
    @_actionFilter ?= actionFilterFromString(Payloads.memberActions)
    @_actionFilter(action)

  isLoggedIn: ->
    !@get('notLoggedIn')

  getMembershipData: (model) ->
    admins = model.adminList.models
    isMe = Auth.isMe(@)
    me = Auth.me()

    # logic
    isOneOtherAdmin = _.some(admins, (admin) => admin.id != @id)
    isMoreThanOneAdmin = admins.length > 1
    isMoreThanOneMember = model.memberList.length > 1
    membership = model.getMembershipFor(@)
    memberIsAdmin = model.getExplicitMemberType(@) == 'admin' || membership?.memberType == 'admin'
    memberIsObserver = model.getExplicitMemberType(@) == 'observer' || membership?.memberType == 'observer'
    memberIsNormal = !(memberIsAdmin || memberIsObserver)
    memberIsVirtual = model.isVirtual(@)
    isAdmin = model.owned() # this checks whether the current member (me) is an admin
    notOrg = model.getExplicitMemberType(@) != 'org'

    # perms
    canChangeRole = isAdmin
    canMakeMember = !memberIsNormal && isOneOtherAdmin && isAdmin
    canMakeObserver = !memberIsObserver && isOneOtherAdmin && isAdmin
    canMakeAdmin = !memberIsAdmin && isAdmin

    # For any model, an admin can always remove any member and a member can always
    # remove himself as long as there is more than one member and another admin remaining.
    # For models except orgs, a member can be removed if the current member (me)
    # can invite members to the board and has equal or higher permissions to
    # the member he's removing.
    canRemove = isMoreThanOneMember && ((isOneOtherAdmin && (isAdmin || isMe)) ||
      (!isMe && notOrg && model.canInviteMembers?() &&
      model.compareMemberType?(me, @) >= 0))
    canDeactivate = canRemove && (model.typeName == 'Organization' && isAdmin && !model.isDeactivated(@) && !memberIsVirtual)

    return {
      isMe
      canRemove
      canDeactivate
      canChangeRole
      memberIsAdmin
      memberIsObserver
      memberIsNormal
      memberIsVirtual
      canMakeMember
      canMakeObserver
      canMakeAdmin
      isMoreThanOneAdmin
      isMoreThanOneMember
    }

  canAddBoardsTo: (org) ->
    org.getMembershipFor(@)?

  isDismissed: (name) ->
    name in (@get('oneTimeMessagesDismissed') ? [])

  dismiss: (name, next) ->
    return next?() if @isDismissed(name)
    @addToSet('oneTimeMessagesDismissed', name, next)

  dismissAd: (adId) ->
    ApiPromise
      url: "#{@urlRoot}/me/messagesDismissed"
      type: 'post'
      data:
        name: "ad-#{adId}"
    .then (data) =>
      @set('messagesDismissed', data.messagesDismissed)
    .done()

  shouldShowPowerUpSuggestionFor: (idPlugin) ->
    return false unless @hasPowerUpSuggestionsEnabled()

    dismissedPowerUpSuggestion = _.findWhere(@getDismissedPowerUpSuggestions(), {
      name: "power-up-suggestions-#{idPlugin}"
    })
    return true unless dismissedPowerUpSuggestion?

    lastDismissal = moment(dismissedPowerUpSuggestion.lastDismissed)
    daysSinceLastDismissal = moment().diff(lastDismissal, 'days')
    daysSinceLastDismissal >= 4

  dismissPowerUpSuggestionFor: (idPlugin) ->
    ApiPromise
      url: "#{@urlRoot}/me/messagesDismissed"
      type: 'post'
      data:
        name: "power-up-suggestions-#{idPlugin}"
    .then (data) =>
      @set('messagesDismissed', data.messagesDismissed)
    .done()

  getDismissedAd: (adId) ->
    messagesDismissed = @get 'messagesDismissed' ? []
    _.find messagesDismissed, (dismissedMessage) ->
      dismissedMessage.name == "ad-#{adId}"

  isAdDismissed: (adId) ->
    dismissedAd = @getDismissedAd(adId)
    if dismissedAd then moment().diff(moment(dismissedAd.lastDismissed), 'days') <= 14 else false

  setDateFirstSawHighlights: ->
    ApiPromise
      url: "#{@urlRoot}/me/messagesDismissed"
      type: 'post'
      data:
        name: "feedback-card-home-page-internal"
    .then (data) =>
      @set('messagesDismissed', data.messagesDismissed)
    .done()

  getDateFirstSawHighlights: ->
    messagesDismissed = @get 'messagesDismissed' ? []
    feedbackCard = _.find messagesDismissed, (dismissedMessage) ->
      dismissedMessage.name == 'feedback-card-home-page-internal'
    if !feedbackCard
      return null
    else
      return feedbackCard.lastDismissed

  shouldShowFeedbackCard: ->
    if @isDismissed('homeFeedbackOrientationCard')
      return false

    messagesDismissed = @get 'messagesDismissed' ? []
    feedbackCard = _.find messagesDismissed, (dismissedMessage) ->
      dismissedMessage.name == 'feedback-card-home-page-internal'
    days = 0
    if feedbackCard
      days = moment().diff(moment(feedbackCard.lastDismissed), 'days')
    return days > 7

  dismissLanguageBannerFor: (locale, next) ->
    @dismiss "new-lang-#{locale}", next

  shouldShowNewLanguageBannerFor: (locale) ->
    locale = Language.normalizeLocale(locale)
    !@isDismissed("new-lang-#{locale}") &&
    @getLocale() != locale &&
    Language.normalizeLocale(window.locale) != locale &&
    Language.mostPreferred(Language.preferred, [@getLocale(), locale]) == locale

  toggleSubscribeOnComment: ->
    @dismissAd('subscribeOnComment')

  dismissGuidedTour: ->
    @dismiss('guided-tour')

  isGuidedTourDismissed: ->
    @isDismissed('guided-tour')

  isSubscribeOnCommentEnabled: ->
    dismissalCount = @getDismissedAd('subscribeOnComment')?.count ? 0
    # Overloading the dismissal count since messagesDismissed
    # does not allow for deletion.
    dismissalCount % 2 == 0

  shouldShowEnterpriseBannerFor: (enterprise) ->
    messagesDismissed = @get 'messagesDismissed' ? []
    shownEnterpriseBanner = _.find messagesDismissed, (dismissedMessage) ->
      dismissedMessage.name == "enterprise-license-banner-shown-#{enterprise.id}"

    if shownEnterpriseBanner
      # don't show the banner again if they saw it less than 24 hours ago
      hours = moment().diff(shownEnterpriseBanner.lastDismissed, 'hours')
      return false if hours < 24

    enterpriseBanner = _.find messagesDismissed, (dismissedMessage) ->
      dismissedMessage.name == "enterprise-license-banner-#{enterprise.id}"

    # show the banner if they have never dimissed it, or if it has been more
    # than 30 days since they dismissed it
    return true if not enterpriseBanner
    days = moment().diff(moment(enterpriseBanner.lastDismissed), 'days')
    return days > 30

  recordEnterpriseBannerShownFor: (enterprise) ->
    ApiPromise
      url: "#{@urlRoot}/me/messagesDismissed"
      type: 'post'
      data:
        name: "enterprise-license-banner-shown-#{enterprise.id}"
    .then (data) =>
      @set('messagesDismissed', data.messagesDismissed)
    .done()

  dismissEnterpriseBannerFor: (enterprise) ->
    ApiPromise
      url: "#{@urlRoot}/me/messagesDismissed"
      type: 'post'
      data:
        name: "enterprise-license-banner-#{enterprise.id}"
    .then (data) =>
      @set('messagesDismissed', data.messagesDismissed)
    .done()

  owned: ->
    Auth.isMe(@)

  prefNames: ['minutesBetweenSummaries']

  getLocale: ->
    if @getPref('locale')
      Language.normalizeLocale @getPref('locale')
    else
      'en'

  getLocales: ->
    if @isLoggedIn()
      [@getLocale(), 'en']
    else
      Language.preferred.map Language.normalizeLocale

  getMemberViewTitle: ->
    username = @get('username')
    fullName = @get('fullName')
    viewTitle = "#{fullName} (#{username})"
    return viewTitle

  toggleColorBlindMode: ->
    if @get('prefs')?
      if @get('prefs').colorBlind
        @setPref('colorBlind', false).save()
      else
        @setPref('colorBlind', true).save()
      $('#classic-body').toggleClass('body-color-blind-mode-enabled', @get('prefs').colorBlind)
    return

  getOpenBoardsByOrg: (editable) ->
    organizations = {}

    for board in @boardList.models when board.isOpen()
      # Do this properly with board.editable when we get memberships working better
      if editable && board.get('myPermLevel') == 'observer'
        continue
      boardData = board.toJSON()

      # It's possible to be on a board that you can see the
      # idOrganization for even though you couldn't see the team.
      idOrg =
        if board.getOrganization()?
          boardData.idOrganization
        else
          ""

      organizations[idOrg] ?=
        boards: []
        displayName: (if idOrg == '' then l('member boards.boards') else @modelCache.get('Organization', idOrg)?.get('displayName'))

      organizations[idOrg].boards.push(boardData)

    idOrgsSorted = _.sortBy _.keys(organizations), (idOrg) ->
      if idOrg == ''
        ''
      else
        organizations[idOrg].displayName

    organizations[idOrg] for idOrg in idOrgsSorted

  getSortedOrgs: ->
    _.clone(@organizationList.models).sort (a, b) ->
      a.get('displayName').localeCompare b.get('displayName')

  checkColorBlindMode: ->
    $('#classic-body').toggleClass('body-color-blind-mode-enabled', @get('prefs')?.colorBlind == true)

  isFeatureEnabled: (feature) ->
    MemberFeatures.isFeatureEnabled(feature, @get('products'))

  isGold: ->
    MemberFeatures.hasProduct(@get('products'))

  isInAnyBCOrganization: ->
    @organizationList.any((org) -> org.isPremium())

  getBillingStrategy: (product) ->
    flatRate: true

  hasMemberAccount: ->
    Accounts.hasAccount(@get('paidAccount')?.standing)

  hasMemberOrOrgAccount: ->
    @hasMemberAccount() || @organizationList.any((org) -> org.hasAccount())

  hasPowerUpSuggestionsEnabled: ->
    maxDismissalCount = getExperiment('powerUpSuggestions').get('maxDismissalCount')
    totalDismissalCount = @getDismissedPowerUpSuggestions().reduce (totalCount, dismissedPowerUpSuggestion) ->
      totalCount + dismissedPowerUpSuggestion.count
    , 0

    totalDismissalCount < maxDismissalCount

  getDismissedPowerUpSuggestions: ->
    messagesDismissed = @get 'messagesDismissed' ? []
    messagesDismissed.filter (dismissedMessage) ->
      dismissedMessage.name.indexOf 'power-up-suggestions' == 0

  allCustomEmoji: ->
    allEmoji = {}
    if @isFeatureEnabled('customEmoji')
      for emoji in @customEmojiList.models
        allEmoji[emoji.get('name')] = emoji.get('url')

    allEmoji

  toJSON: (opts = {}) ->
    data = super
    if opts.hasPassword
      data.hasPassword = ('password' in data.loginTypes)

    data.accountStanding = Accounts.standingName(@get('paidAccount')?.standing)

    data

  editing: (msg = {}) ->
    if _.isEqual(msg, @lastMessage)
      return

    @lastMessage = msg

    clearTimeout @clearLastTimeout

    @clearLastTimeout = @setTimeout =>
      @lastMessage = null
    , (EDITING_AUTO_CLEAR_MS / 2)

    if Auth.isLoggedIn()
      ApiAjax
        url: "#{@urlRoot}/#{@id}/editing"
        type: 'post'
        background: true
        data: _.clone(msg)

  removeMembershipConfirmationKey: (model) ->
    isOrg = model.typeName == 'Organization'
    return if Auth.isMe(@)
      if isOrg
        'leave org'
      else
        'leave board'
    else
      if isOrg
        'remove member from org'
      else if model.isDeactivated(@)
        'remove deactivated member from board'
      else
        'remove member from board'

  unreadNotifications: ->
    if getExperiment('cardNotifications').get('showCards')
      countsByGroup = @get 'notificationsCount'
      if getExperiment('bellCount').get('markBell')
        countsByGroup = @notificationsSeenState.getNewNotifications(countsByGroup)

      count = Object.keys(countsByGroup).length
    else
      count = @modelCache.all('Notification')
        .filter (notification) -> notification.get('unread')
        .length

    count

  setNotifications: ({ notifications, setFn, errorFn, data }) ->
    _.forEach notifications, setFn

    ApiAjax
      url: '/1/notifications/all/read'
      type: 'post'
      retry: false
      data: data
      error: ->
        _.forEach notifications, errorFn

  clearAllNotifications: ->
    unreadNotifications = @modelCache.all('Notification')
      .filter (notification) -> notification.get('unread')
    dateRead = new Date()
    oldCount = @get('notificationsCount')

    @setNotifications
      notifications: unreadNotifications
      setFn: (notif) ->
        if getExperiment('cardNotifications').get('showCards')
          notif.set
            dateRead: dateRead
            unread: false
      errorFn: (notif, i) =>
        if getExperiment('cardNotifications').get('showCards')
          if i == 0
            @set 'notificationsCount', oldCount
          notif.set
            dateRead: null
            unread: true

    @set 'notificationsCount', {}

    return

  initializeDesktopNotifications: ->
    @idLastDesktopNotification = _.chain(@modelCache.all('Notification'))
      .pluck("id")
      .compact()
      .sort()
      .last()
      .value() ? ""

    @listenTo @modelCache, 'add:Notification', @showDesktopNotification

  initializeNotifications: ->
    if !Auth.isLoggedIn()
      return
    myId = @get('id')
    filterState = @notificationFilterState = new NotificationFilterState(myId)
    username = @get('username')
    pageSize = Notification.PAGE_SIZE

    # SimpleTest needs the current member to be in the ModelCache.
    # Once this experiment goes, so can the waitFor call here
    @modelCache.waitFor 'Member', @get('id'), =>
      initialLoad =
        if getExperiment('cardNotifications').get('showCards')
          if filterState.getVisibility() == filterState.VISIBILITY_ALL
            ModelLoader.loadMoreNotificationGroupData(username, pageSize)
          else
            ModelLoader.loadMoreUnreadNotifications(username, pageSize)
        else
          ModelLoader.loadMoreNotificationData(username, pageSize)
      @loadNotificationsCount().then =>
        initialLoad.then =>
          @initializeDesktopNotifications()

      @notificationsSeenState = new NotificationsSeenState @

  loadNotificationsCount: ->
    if getExperiment('cardNotifications').get('showCards')
      ModelLoader
        .loadMemberNotificationsCount(@id)
        .then (notificationsCount) =>
          @set 'notificationsCount', notificationsCount
    else
      Promise.resolve()

  # Ensures that all notifications in the Model Cache have an appropriate group
  ensureGroup: ->
    return if !getExperiment('cardNotifications').get('showCards')
    idCards = @modelCache.all('Notification')
    .map (notification) ->
      notification.get('data')?.card?.id
    .filter (idCard) -> idCard?
    idCards = _.uniq(idCards)

    idCardGroups = @modelCache.all('NotificationGroup')
    .map (group) -> group.get('id')
    .filter (idGroup) -> idGroup.startsWith('Card:')
    .map (idGroup) -> idGroup.replace('Card:', '')

    needToFetch = _.difference(idCards, idCardGroups)
    if needToFetch.length > 0
      ModelLoader.loadNotificationGroups(needToFetch)

  updateNotificationCount: (eventType) => (notification) =>
    if notification?
      idCard = notification.get('data')?.card?.id
      notificationsCount = _.clone @get 'notificationsCount'
      notifType =
        if idCard?
          "Card:#{idCard}"
        else
          "Notification:#{notification.get('id')}"

      notificationsCount[notifType] ?= 0
      isUnread = notification.get 'unread'
      switch eventType
        when "add"
          isNew = !@modelCache.all('Notification').some (n) ->
            n.get('id') > notification.get('id')
          if isUnread && isNew
            notificationsCount[notifType]++
          else if !isNew
            notificationsCount[notifType]--
        when "change"
          if isUnread
            notificationsCount[notifType]++
          else
            notificationsCount[notifType]--
        when "delete"
          if isUnread
            notificationsCount[notifType]--

      @set 'notificationsCount', _.pick(notificationsCount, _.identity)

  showDesktopNotification: (notification) ->
    if !DesktopNotification.enabled()
      return

    # Only do a desktop notification if this notification is *newer* than the
    # last one we've seen
    if notification.id <= @idLastDesktopNotification
      return

    @idLastDesktopNotification = notification.id

    Promise.try ->
      # It's possible that we've just re-connected our websocket and we're
      # receiving old notifications.  This commonly happens when a laptop
      # wakes up.
      delta = Date.now() - Time.serverToClient(notification.get('date'))
      if delta < Util.getMs(minutes: 1)
        # The notification just happened, so consider the notification to
        # be current
        notification
      else
        # The notification happened a while ago, so it's possible that
        # it's actually been read.  Fetch the latest version of the
        # notification
        ModelLoader.loadNotification(notification.id)
    .then (latestNotification) ->
      if latestNotification.get('unread')
        new DesktopNotification(latestNotification)
    .done()

  getNotificationFilterState: -> @notificationFilterState

  getMobileTempPassword: (next) ->
    ApiAjax
      url: '/1/members/me/loginToken'
      type: 'post'
      data:
        mode: 'password'
      success: (data) -> next(data.password)
    return

  maxFileSize: ->
    if @isFeatureEnabled('largeAttachments')
      250 * 1024 * 1024
    else
      10 * 1024 * 1024

  canUploadAttachment: (file) ->
    return file.size < @maxFileSize()

  accountNewerThan: (date) ->
    Util.idToDate(@id) > date

  getShowDetails: ->
    Storage.get('showDetails') ? if @accountNewerThan(HIDE_DETAILS_DEFAULT_DATE) then false else true

  setShowDetails: (value) ->
    Storage.set('showDetails', value)

  enterpriseWithRequiredConversion: ->
    # If the user already belongs to an enterprise, then they already
    # are an enterprise member.
    return if @get('idEnterprise')?
    org = @organizationList.find (org) ->
      org.get('idEnterprise')? \
      && org.getEnterprise()? \
      && org.getEnterprise().get('prefs')?.mandatoryTransferDate \
      && !org.getEnterprise().get('prefs')?.ssoOnly
    if org?
      org.getEnterprise()

  missedTransferDate: ->
    @get('missedTransferDate')

  hasBCPowerUps: ->
    @organizationList.any((org) -> org.isFeatureEnabled('plugins'))

  # Get the number of power-ups a user is allowed to turn on for a board
  getPowerUpsLimit: ->
    # All boards can enable 1 power-up
    # Gold members can enable 3 power-ups on all boards
    # BC members can enable unlimited power-ups on all boards
    if @hasBCPowerUps()
      Infinity
    else if @isFeatureEnabled('threePlugins')
      3
    else
      1

  isEnterpriseAdmin: ->
    @get('confirmed') && @get('idEnterprisesAdmin')?.length > 0

  isEnterpriseAdminOf: (enterprise) ->
    @isEnterpriseAdmin() && @get('idEnterprisesAdmin').indexOf(enterprise.id) >= 0

  isSSOOnly: ->
    idEnterprise = @get('idEnterprise')

    if idEnterprise && (enterprise = @modelCache.get('Enterprise', idEnterprise))?
      enterprise.get('prefs').ssoOnly
    else
      false

  loadNextSurveyDate: ->
    simulatingNps = $.cookie('simulateNps')?

    if !getExperiment('npsSurvey')?.get('showSurvey') && !simulatingNps
      return

    ApiPromise
      background: true
      url: "#{ @url() }/nps/nextSurveyDate"
      data:
        pageId: 'header'
    .then (result) =>
      date = Date.parse(result.nextSurveyDate)
      if date < Date.now()
        ApiPromise
          background: true
          url: "#{ @url() }/nps"
          data:
            pageId: 'header'
        .then (nps) ->
          { cancellations, next_survey_date, opted_out, optout_available, past_next_survey_date } = nps
          past_next_survey_date && cancellations == 0 && !opted_out
      else
        false
    .catch ApiError, =>
      false
    .then (showNps) =>
      @update({
        showNps: showNps || simulatingNps
      })
    .done()

  shouldShowSurvey: ->
    @get('showNps') == true

  dismissSurvey: ->
    @set('showNps', false)

    Storage.unset('npsDisplayCount')

    ApiPromise
      background: true
      url: "#{ @url() }/nps/cancel"
      method: 'post'
      data:
        pageId: 'header'
    .done()

  trackShowSurvey: ->
    displayCount = Storage.get('npsDisplayCount') ? 0
    displayCount++
    Storage.set('npsDisplayCount', displayCount)

    track('NPS', 'Shown Survey', 'Count', undefined, displayCount)

    ApiPromise
      background: true
      url: "#{ @url() }/nps/show"
      method: 'post'
      data:
        pageId: 'header'
        displayCount:  displayCount
    .done()

  submitSurvey: ({ completed, score, comment, usage, trackScore, trackUsage }) ->
    @set('showNps', false)

    if trackScore
      # The survey gets submitted again if they fill out the
      # follow up, but we only want to send the score one time
      track('NPS', 'Submit Survey', 'Score', undefined, score)

    if trackUsage
      track('NPS', 'Submit Survey', 'Usage', usage || "Not Specified")

    ApiPromise
      background: true
      url: "#{ @url() }/nps/survey"
      method: 'post'
      data:
        pageId: 'header'
        survey_rating: score
        survey_attributes_comment: comment
        survey_attributes_role: usage
        survey_completed: completed
    .done()

  shouldShowMarketingOptIn: ->
    # Show marketing opt in survey if the account is confirmed, more than
    # 3 days old, and hasn't previously set marketingOptIn

    @get('confirmed') \
      && ldclient.variation('scale.marketing_opt_in_notification', false) \
      && (new Date() - Util.idToDate(@id)) > Util.getMs(days: 3) \
      && !@get('marketingOptIn')?.date

  setMarketingOptIn: (optedIn) ->
    @update "marketingOptIn/optedIn", optedIn, ->

  setPluginData: (idPlugin, visibility, data) ->
    @pluginDataList.upsert(idPlugin, visibility, data)

  getPluginData: (idPlugin) ->
    @pluginDataList.dataForPlugin(idPlugin)

  clearPluginData: (idPlugin) ->
    @pluginDataList.for(idPlugin, 'private')?.destroy()

  snoopPluginData: (idPlugin) ->
    memberPluginData = @pluginDataList.snoopDataForPlugin(idPlugin)

  fetchEnterpriseUserType: (enterpriseId) ->
    ModelLoader.loadMemberEnterpriseUserType(enterpriseId, @get('id'))

  fetchEnterpriseActive: (enterpriseId) ->
    ModelLoader.loadMemberEnterpriseActive(enterpriseId, @get('id'))

  shouldShowNoticeOfTosChange: ->
    # Show notice of ToS change if the user's account was created before
    # November 1, 2018 and the user has not already dismissed the message by
    # clicking "I Agree"
    messagesDismissed = @get 'messagesDismissed' ? []
    ldclient.variation('treehouse.in_app_notif_tos_change', false) \
      && new Date(2018, 10, 1) > Util.idToDate(@id) \
      && !(_.contains (_.pluck messagesDismissed, 'name'), '1-nov-2018-tos-change-accepted')

  agreeToAndDismissTosChange: ->
    ApiPromise
      url: "#{@urlRoot}/me/messagesDismissed"
      type: 'post'
      data:
        name: "1-nov-2018-tos-change-accepted"
    .then (data) =>
      @set('messagesDismissed', data.messagesDismissed)
    .done()



// WEBPACK FOOTER //
// ./app/scripts/models/member.coffee